export function buyerFileId(clientId) {
  return `buyer--${clientId}`;
}

export function sellerFileId(clientId) {
  return `seller--${clientId}`;
}

export function parseFileRouteId(routeId) {
  const id = decodeURIComponent(String(routeId || ""));
  if (id.startsWith("buyer--")) return { kind: "buyer", clientId: id.slice(7), transactionId: null, fileId: id };
  if (id.startsWith("seller--")) return { kind: "seller", clientId: id.slice(8), transactionId: null, fileId: id };
  return { kind: "transaction", clientId: null, transactionId: id, fileId: id };
}

export function fileRouteId({ transactionId, fileType, clientId }) {
  if (transactionId) return transactionId;
  if (fileType === "seller" && clientId) return sellerFileId(clientId);
  if (clientId) return buyerFileId(clientId);
  return "";
}
